"use client";

import * as React from 'react';
import { useRouter, useSearchParams, usePathname } from 'next/navigation';
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from '@/components/ui/select';

// Only options the API actually sorts on real signals.
// Removed: Top Rated (no rating data), Most Liked / Most Viewed
// (no like or view tracking on galleries yet — backend was sorting
// by image count, which lies). Re-add when those metrics are real.
const SORT_OPTIONS: Array<{ value: string; label: string }> = [
  { value: 'latest', label: 'Newest' },
  { value: 'trending', label: 'Trending' },
];
const WINDOW_OPTIONS: Array<{ value: string; label: string }> = [
  { value: 'all', label: 'All Time' },
  { value: 'week', label: 'Past Week' },
  { value: 'month', label: 'Past Month' },
];

export default function GallerySortBar({ initial = 'latest' }: { initial?: string }) {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const rawSort = (searchParams?.get('sort') || initial || 'latest').toLowerCase();
  // Coerce removed legacy sort keys back to the new default
  const current = SORT_OPTIONS.some(o => o.value === rawSort) ? rawSort : 'latest';
  const win = ((searchParams?.get('window') || 'all') as string).toLowerCase();

  function onChange(next: string) {
    const params = new URLSearchParams(searchParams?.toString() || '');
    if (next && next !== 'latest') params.set('sort', next); else params.delete('sort');
    router.replace(`${pathname}?${params.toString()}`);
  }
  function onWindow(next: string) {
    const params = new URLSearchParams(searchParams?.toString() || '');
    if (next && next !== 'all') params.set('window', next); else params.delete('window');
    router.replace(`${pathname}?${params.toString()}`);
  }

  return (
    <div className="flex items-center gap-2">
      <div className="w-44">
        <Select value={current} onValueChange={onChange}>
          <SelectTrigger className="w-full">
            <SelectValue placeholder="Sort">{SORT_OPTIONS.find(o => o.value === current)?.label || 'Newest'}</SelectValue>
          </SelectTrigger>
          <SelectContent>
            {SORT_OPTIONS.map(o => (<SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>))}
          </SelectContent>
        </Select>
      </div>
      <div className="w-40">
        <Select value={win || 'all'} onValueChange={onWindow}>
          <SelectTrigger className="w-full">
            <SelectValue placeholder="Time">{WINDOW_OPTIONS.find(o => o.value === (win || 'all'))?.label || 'All Time'}</SelectValue>
          </SelectTrigger>
          <SelectContent>
            {WINDOW_OPTIONS.map(o => (<SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
